import React, { Component } from "react";
import { Row, Col, Card, CardBody, Badge } from "reactstrap";
import Moment from "react-moment";
import ReactPaginate from "react-paginate";
import { Redirect, withRouter } from '../../utils/router-compat';
import {
  faAngleRight,
  faChevronLeft,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FleetManagerService from "../../services/FleetManagerService";
import InvoiceVerificationDetail from "../../components/FleetManager/InvoiceVerification/InvoiceVerificationDetail";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";

class IndirectBillingReportMonthWise extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToIndirectBillingReport: false,
      indirectBillingMonthWiseData: {},
      qMonth: "",
      selectedInvoiceForVerification: {},
      isLoading: false,
      year_name: {},
      year: null
    };
  }

  componentWillMount() {
    let { qMonth } = this.state;
    const query = new URLSearchParams(this.props.location.search);

    qMonth = {
      id: window.atob(query.get("id")),
      month: window.atob(query.get("month"))
    };

    this.setState(
      {
        qMonth,
        year_name: query.get("yearname") && query.get("yearname"),
        year: query.get("year") && query.get("year")
      },
      () => {
        this.getIndirectBillingReportMonthWise({
          monthId: qMonth.id,
          page: 1,
          pagesize: 10,
          status: "all",
          year: this.state.year
        });
      }
    );
  }

  getIndirectBillingReportMonthWise = async q => {
    let { indirectBillingMonthWiseData, isLoading } = this.state;
    try {
      isLoading = true;
      this.setState({ isLoading });
      const {
        data
      } = await FleetManagerService.getIndirectBillingReportMonthWise(q);

      if (data && data.data) {
        indirectBillingMonthWiseData = data.data;
        indirectBillingMonthWiseData.pageCount =
          Math.trunc(indirectBillingMonthWiseData.total_count / 10) + 1;
        indirectBillingMonthWiseData.page = q.page;
      }
      isLoading = false;
      this.setState({ indirectBillingMonthWiseData, isLoading });
    } catch (error) {
      console.log(error);
      isLoading = false;
      this.setState({ isLoading });
    }
  };

  handlePageClick = e => {
    window.scroll(0, 0);
    const { qMonth } = this.state;
    this.getIndirectBillingReportMonthWise({
      monthId: qMonth.id,
      page: e.selected + 1,
      pagesize: 10,
      status: "all"
    });
  };

  getPendingOfftakeById = async item => {
    let { selectedInvoiceForVerification, isLoading } = this.state;
    try {
      isLoading = true;
      this.setState({ isLoading });
      const obj = {
        id: item.uuid
      };

      const { data } = await FleetManagerService.getOfftakeEntryById(obj);

      if (data.data && data.data[0]) {
        selectedInvoiceForVerification = data.data[0];
      }
      isLoading = false;
      this.setState({ selectedInvoiceForVerification, isLoading });
    } catch (error) {
      console.log(error);
      isLoading = false;
      this.setState({ isLoading });
    }
  };

  goToIndirectBillingReport = () => {
    let { redirectToIndirectBillingReport } = this.state;
    redirectToIndirectBillingReport = true;
    this.setState({ redirectToIndirectBillingReport });
  };

  render() {
    const {
      qMonth,
      isLoading,
      indirectBillingMonthWiseData,
      redirectToIndirectBillingReport,
      selectedInvoiceForVerification
    } = this.state;
    return (
      <div>
        {isLoading && <CustomSpinner />}
        {redirectToIndirectBillingReport && (
          <Redirect to="/indirectBillingReport" />
        )}
        <Row>
          <Col>
            <div style={{ display: "flex" }}>
              <span
                onClick={this.goToIndirectBillingReport}
                className="select-vehicle-label"
                style={{ color: "#545cd8", cursor: "pointer" }}
              >
                Indirect Billing Report
              </span>
              &nbsp;&nbsp;
              <FontAwesomeIcon
                icon={faAngleRight}
                style={{
                  fontSize: "26px",
                  cursor: "pointer",
                  marginTop: "-5px"
                }}
                color="#fdbb1f"
              />
              &nbsp;&nbsp;
              <span className="Offtake-Entry---Invo">
                Verification requests for {qMonth.month}{" "}
                {this.state.year_name ? "( " + this.state.year_name + " )" : ""}
              </span>
            </div>
          </Col>
        </Row>
        <Row className="c-top-15">
          <Col xl="6" md="6" sm="12" xs="12">
            <Card>
              <CardBody>
                <div className="Total-Verification-R">
                  Total Verification Requests:{" "}
                  {indirectBillingMonthWiseData.total_count}
                </div>
                <table
                  className="table table-bordered table-responsive"
                  style={{ marginTop: "12px" }}
                >
                  <thead
                    id="invoice-table-head"
                    className="offtake-check-table-head"
                  >
                    <tr>
                      <th>Fleet Name and Code</th>
                      <th>Invoice Number </th>
                      <th>Purchase Date</th>
                      <th>Submission Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody id="invoice-table-body">
                    {(indirectBillingMonthWiseData.offtake_entries || []).map(
                      (item, i) => {
                        return (
                          <tr key={i}>
                            <td>
                              <span
                                onClick={e => this.getPendingOfftakeById(item)}
                                className="Download-Full-Report"
                                style={{
                                  fontSize: "12px",
                                  cursor: "pointer",
                                  fontWeight: "normal",
                                  textTransform: "capitalize"
                                }}
                              >
                                {item.owner_name} <br />
                              </span>
                              {item.code}
                            </td>
                            <td>{item.invoice_number}</td>
                            <td>
                              <Moment format="DD MMM YYYY">
                                {item.purchase_date}
                              </Moment>
                            </td>
                            <td>
                              <Moment format="DD MMM YYYY">
                                {item.created_at}
                              </Moment>
                            </td>
                            <td>
                              {(item.status || "").toLowerCase() ===
                                "pending_zfm" && (
                                <Badge
                                  color="primary"
                                  className="offtake-status-table-zfm"
                                  style={{
                                    backgroundColor: "#e47927 !important"
                                  }}
                                >
                                  Pending ZFM
                                </Badge>
                              )}

                              {(item.status || "").toLowerCase() ===
                                "pending" && (
                                <Badge
                                  color="primary"
                                  className="offtake-status-table"
                                  style={{
                                    backgroundColor: "#e47927 !important"
                                  }}
                                >
                                  {item.status}
                                </Badge>
                              )}

                              {(item.status || "").toLowerCase() ===
                                "approved" && (
                                <Badge
                                  color="success"
                                  className="offtake-status-table"
                                  style={{
                                    backgroundColor: "#51b856 !important"
                                  }}
                                >
                                  {item.status}
                                </Badge>
                              )}

                              {(item.status || "").toLowerCase() ===
                                "rejected" && (
                                <Badge
                                  color="danger"
                                  className="offtake-status-table"
                                  style={{
                                    backgroundColor: "#e66c6c !important"
                                  }}
                                >
                                  {item.status}
                                </Badge>
                              )}
                              <br />
                              <span
                                title={item.remark}
                                className="incorrect-entries-label text-overflow-dots"
                                style={{ width: "50px !important" }}
                              >
                                {item.remark}
                              </span>
                            </td>
                          </tr>
                        );
                      }
                    )}

                    {(indirectBillingMonthWiseData.offtake_entries || [])
                      .length === 0 && (
                      <tr>
                        <td
                          colSpan="6"
                          style={{ fontSize: "18px", color: "grey" }}
                        >
                          <center>No records found</center>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {(indirectBillingMonthWiseData.offtake_entries || []).length !==
                  0 && (
                  <div className="pull-right" style={{ display: "flex" }}>
                    <span style={{ marginTop: "7px" }}>
                      <span className="showing">Showing </span>
                      <span className="showing-page">
                        {`${indirectBillingMonthWiseData.page - 1}1`}-
                        {(indirectBillingMonthWiseData.page - 1) * 10 +
                          (indirectBillingMonthWiseData.offtake_entries || [])
                            .length <
                        10
                          ? "0"
                          : ""}
                        {(indirectBillingMonthWiseData.page - 1) * 10 +
                          (indirectBillingMonthWiseData.offtake_entries || [])
                            .length}
                        &nbsp;of{" "}
                        {indirectBillingMonthWiseData.total_count < 10
                          ? "0"
                          : ""}
                        {indirectBillingMonthWiseData.total_count}
                      </span>
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    <ReactPaginate
                      previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                      nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                      breakLabel="..."
                      breakClassName="break-me"
                      pageCount={indirectBillingMonthWiseData.pageCount}
                      // pageCount={18}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={this.handlePageClick}
                      containerClassName="pagination"
                      subContainerClassName="pages pagination"
                      pageLinkClassName="c-page"
                      previousLinkClassName="c-prev"
                      nextLinkClassName="c-next"
                      breakLinkClassName="c-break-line"
                      activeClassName="active"
                      activeLinkClassName="c-page-link"
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
          <Col>
            <Card>
              <CardBody>
                <InvoiceVerificationDetail
                  selectedInvoiceForVerification={
                    selectedInvoiceForVerification
                  }
                  from="indirectBilling"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(IndirectBillingReportMonthWise);
